export { defaultProps, RichTextEditor } from './RichTextEditor'
